import { render, staticRenderFns } from "./fbpClaims.vue?vue&type=template&id=5551b811&scoped=true&lang=html"
import script from "./fbpClaims.vue?vue&type=script&lang=js"
export * from "./fbpClaims.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5551b811",
  null
  
)

export default component.exports